module["exports"] = ["واحد #", "# طبقه"];